import { render } from "./EnDatagridPagination.vue?vue&type=template&id=449a929f&ts=true"
import script from "./EnDatagridPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnDatagridPagination.vue?vue&type=script&setup=true&lang=ts"

import "./EnDatagridPagination.vue?vue&type=style&index=0&id=449a929f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/datagrid/slots/EnDatagridPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "449a929f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('449a929f', __exports__)) {
    api.reload('449a929f', __exports__)
  }
  
  module.hot.accept("./EnDatagridPagination.vue?vue&type=template&id=449a929f&ts=true", () => {
    api.rerender('449a929f', render)
  })

}


export default __exports__